module.exports = __webpack_public_path__ + "vue-tags-input/assets/fonts/icomoon-f7f0f49e68387a3422897a6ca842c67e.eot";